const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoExtended(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3463 1465",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.678,1172.117C633.678,1330.508 492.64,1459.101 318.922,1459.101C145.204,1459.101 4.167,1330.508 4.167,1172.117C4.167,1013.727 145.204,885.133 318.922,885.133C376.578,885.133 459.353,888.055 459.353,888.055L459.353,133.838L633.678,4.167L634.783,1172.117L633.678,1172.117Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.874,1156.891C1325.08,1327.955 1208.579,1459.101 1031.299,1459.101C854.018,1459.101 710.088,1315.172 710.088,1137.891C710.088,1123.311 707.366,1108.957 709.251,1094.889L709.191,381.07L886.395,508.787L886.395,765.785L1190.707,763.713L1352.509,880.225L886.395,882.297L887.626,1128.909C887.626,1216.889 941.001,1286.246 1028.981,1286.246C1116.961,1286.246 1153.408,1240.727 1169.985,1156.891L1347.874,1156.891Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.673,1139.187C1596.672,1139.527 1596.67,1139.868 1596.67,1140.208C1596.67,1141.108 1596.678,1142.005 1596.695,1142.9L1597.992,1286.246L1739.132,1286.246C1817.76,1286.246 1881.595,1222.41 1881.595,1143.783L1881.595,1040.772L2058.026,922.608L2058.026,1140.208C2058.026,1160.33 2056.158,1180.019 2052.586,1199.112C2024.92,1347.015 1895.012,1459.101 1739.132,1459.101L1739.132,1460.444L1420.239,1459.101L1420.239,881.009L1597.992,764.498L1596.673,1139.187Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2129.242,1460.331L2129.242,882.352L2306.989,763.155L2306.989,910.111C2353.476,885.946 2389.136,886.692 2446.556,886.363C2564.259,885.689 2667.084,944.451 2721.859,1030.632C2748.583,1072.678 2763.87,1121.41 2763.87,1173.347L2763.87,1460.331L2589.144,1460.444L2589.144,1199.204C2589.144,1120.756 2536.183,1057.067 2448.195,1057.067C2360.207,1057.067 2306.989,1118.201 2306.989,1196.649L2306.989,1460.444L2129.242,1460.331Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3462.861,1148.449C3459.185,1321.271 3317.738,1460.444 3144.041,1460.444C2970.344,1460.444 2828.897,1321.271 2825.221,1148.449C2825.172,1146.155 2823.509,1122.857 2824.417,1113.061C2823.509,1103.265 2825.51,1064.406 2826.221,1055.725C2839.623,892.017 2976.902,763.155 3144.041,763.155C3311.18,763.155 3448.458,892.017 3461.861,1055.725L3005.66,1055.725L3005.66,1148.449C3005.66,1224.501 3067.405,1286.246 3143.457,1286.246C3219.509,1286.246 3281.253,1224.501 3281.253,1148.449L3462.861,1148.449Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExtended);
export default __webpack_public_path__ + "static/media/logo-extended.65580f93eb8782e9fa51310e817d606f.svg";
export { ForwardRef as ReactComponent };